function updateScript() {
    const elementsItems = document.querySelectorAll(".content.product-content");
    
    if (elementsItems.length > 12) {
        let countIndex = 0;
        const extracontentelement = document.querySelectorAll(".custom-usp-contents");
        extracontentelement[countIndex].classList.add("flex");
        $(document).ready(function () {
            $(".content.product-content").slice(0, 12).show();
            $("#loadMore").on("click", function (e) {
    
                e.preventDefault();
                countIndex++;

                if (extracontentelement[countIndex]) {
                    extracontentelement[countIndex].classList.add("flexs");
                }

                $(".content.product-content:hidden").slice(0, 12).slideDown();
                if ($(".content.product-content:hidden").length == 0) {
                    $("#loadMore").text("No Content").addClass("hidden");
                }

            });
        })
    } else {
        $(".content.product-content").show();
        $("#loadMore").hide()
    }

}

updateScript();
function checkboxChange() {
   setTimeout(() => {
        
           updateScript();
      }, 2000);
}



new Swiper('.collection-tabs-box', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 30,
    paginationClickable: true,
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
     0: {
      slidesPerView: 1.8,
      spaceBetween: 10
    },
    580: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    1300: {
      slidesPerView: 4,
      spaceBetween: 30
    },  
  }
});